var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./JoinBenefits.jinja');
require('./JoinBenefits.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/JoinBenefits/JoinBenefits.js
// module id = 181
// module chunks = 0